import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Cuánto cuesta SAINT® TMS?",
    answer:
      "El costo de SAINT® TMS depende de varios factores. El pago directo puede oscilar entre $25,000 y $28,000. SAINT® suele ser de pago directo. El costo real depende del plan individual; le proporcionamos un resumen del costo antes de iniciar el tratamiento.",
  },
  {
    question: "¿Cubre el seguro SAINT® TMS?",
    answer:
      "SAINT® suele ser de pago directo. Verificamos los beneficios de cada paciente sin costo. La cobertura varía según el plan.",
  },
  {
    question: "¿Hay opciones de financiamiento para SAINT®?",
    answer:
      "Puede haber opciones de financiamiento. Analizamos las opciones disponibles durante la consulta.",
  },
];

export const esSaintTmsCost = makeEsArticle({
  slug: "saint-tms-cost",
  title: "Costo de SAINT® TMS: pago directo y financiamiento",
  description:
    "El costo de SAINT® TMS: componentes del costo, pago directo (que puede oscilar entre $25,000 y $28,000), seguro, opciones de financiamiento y cómo verificar sus beneficios sin costo.",
  h1: "Costo de SAINT® TMS",
  breadcrumbLabel: "Costo de SAINT® TMS",
  shortAnswer:
    "El costo de SAINT® TMS depende de varios factores. El pago directo puede oscilar entre $25,000 y $28,000. SAINT® suele ser de pago directo y no suele estar cubierto por los seguros. Verificamos los beneficios de cada paciente sin costo. Puede haber opciones de financiamiento disponibles.",
  keyTakeaways: [
    "El pago directo puede oscilar entre $25,000 y $28,000.",
    "SAINT® suele ser de pago directo.",
    "Verificamos los beneficios de cada paciente sin costo.",
    "Puede haber opciones de financiamiento disponibles.",
    "Le proporcionamos un resumen del costo antes de iniciar el tratamiento.",
  ],
  sections: [
    {
      heading: "Componentes del costo de SAINT®",
      paragraphs: [
        "El costo de SAINT® TMS incluye la resonancia magnética funcional (fMRI) previa, las 50 sesiones de tratamiento durante cinco días, el equipo clínico, y el seguimiento posterior.",
        "El pago directo puede oscilar entre $25,000 y $28,000. El costo real depende del plan individual; le proporcionamos un resumen del costo antes de iniciar el tratamiento.",
      ],
    },
    {
      heading: "SAINT® y el seguro",
      paragraphs: [
        "SAINT® suele ser de pago directo. La TMS convencional está ampliamente cubierta por los seguros, pero SAINT® —por su ritmo acelerado y su orientación por fMRI— suele no estar cubierta por la mayoría de los planes.",
        "[[Verificamos los beneficios|/es/saint-tms-insurance-coverage]] de cada paciente sin costo, sea cual sea su aseguradora. La cobertura varía según el plan.",
      ],
    },
    {
      heading: "Opciones de financiamiento",
      paragraphs: [
        "Puede haber opciones de financiamiento disponibles. Analizamos las opciones durante la consulta. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
